import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Header from '~/components/Header';
import Footer from '~/components/Footer';
import styles from './layout.styles';
const Container = styled.div `
  ${styles}
`;
const FullLayout = ({ registerForm }) => {
    return (_jsxs(Container, { children: [_jsx(Header, { registerForm: registerForm }), _jsx("div", { className: "layout-body", children: _jsx("div", { className: "contents", children: _jsx(Outlet, {}) }) }), _jsx("footer", { children: _jsx(Footer, {}) })] }));
};
export default FullLayout;
